import Rollbar from './rollbar';
import { LogArgument } from 'rollbar';

/**
 * SDK users might not handle the error in the callback function.
 * So, we need to catch their errors, ignore them or mark them as "debug".
 */
type Callback<T> = (err: unknown, data: T | null) => void;
function wrapCallbackWithErrorHandling<T>(callback: Callback<T>): Callback<T> {
  return (err: unknown, data: T | null) => {
    try {
      callback(err, data);
    } catch (callbackError) {
      // This error actually occurs in the user's code, so we don't need to treat it as an error on our SDK.
      // TODO: we should stop sending these callbackError to rollbar in the future if we ensure these are redundant.
      Rollbar.debug(callbackError as LogArgument);
    }
  };
}

export default wrapCallbackWithErrorHandling;
